import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { switchMap, map, catchError, of } from 'rxjs';
import { loadGridState, loadGridStateFailure, loadGridStateSuccess, saveGridState, saveGridStateFailure, saveGridStateSuccess } from './bryntum-grid-state.actions';
import { BryntumGridStateService } from './bryntum-grid-state.service';

@Injectable()
export class BryntumGridStateEffects {
    constructor(
        private actions$: Actions,
        private bryntumGridStateService: BryntumGridStateService,
        private router: Router
    ) { }

    loadBryntumGridState$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadGridState),
            switchMap((action) =>
                this.bryntumGridStateService.loadGridState(action.bryntumComponentTypeId).pipe(
                    map(bryntumGridState => loadGridStateSuccess({ bryntumComponentTypeId: action.bryntumComponentTypeId, state: bryntumGridState })),
                    catchError(error => of(loadGridStateFailure({ error })))
                )
            )
        )
    );

    saveBryntumGridState$ = createEffect(() =>
        this.actions$.pipe(
            ofType(saveGridState),
            switchMap((action) =>
                this.bryntumGridStateService.saveGridState(action.bryntumComponentTypeId, action.configuration).pipe(
                    map(() => saveGridStateSuccess({ bryntumComponentTypeId: action.bryntumComponentTypeId, state: action.configuration })),
                    catchError(error => of(saveGridStateFailure({ error })))
                )
            )
        )
    );
}